export const productCollectionStates = [
  { key: 'ALL', label: '全部商品' },
  { key: 'NOT_PUBLISHED', label: '未发布' },
  { key: 'PUBLISHING', label: '发布中' },
  { key: 'PUBLISHED', label: '已发布' },
  { key: 'NEEDS_ATTENTION', label: '需处理' },
] as const
export type ProductCollectionState = typeof productCollectionStates[number]['key']

export function productCollectionState(search: string): ProductCollectionState {
  const value = new URLSearchParams(search).get('publication')
  return productCollectionStates.find(item => item.key === value)?.key ?? 'ALL'
}

export function productCollectionUrl(state: string, search = ''): string {
  const query = new URLSearchParams(search)
  query.delete('page')
  if (state === 'ALL') query.delete('publication')
  else query.set('publication', state)
  return `/products${query.size ? `?${query}` : ''}`
}
